(function() {
  'use strict';

  angular.module('component.eventTypes')
    .component('eventTypeForm', {
      templateUrl: 'app/components/event-types/form.html',
      controller: 'EventTypeController',
      controllerAs: 'eventTypeCtrl',
      bindings: {
        eventTypeId: '<',
        action: '<',
        doc: '<'
      }
    });
})();
